
import IconClock from '../../../Icons/Clock';
import IconProtect from '../../../Icons/Protect';
import IconQRCode from '../../../Icons/QRCode';

const Pix = () => {
  return <>
    <div className='grid grid-cols-1 sm:grid-cols-3 gap-1 sm:gap-2'>
      <div className='p-4 rounded-lg bg-gray-100 flex flex-col gap-1'>
        <div className='min-h-8'>
          <IconClock className='text-green-700' />
        </div>
        <p className='text-black font-medium leading-tight'>Aprovação imediata</p>
        <p className='text-sm text-gray-500'>O pagamento com Pix é processado rapidamente.</p>
      </div>

      <div className='p-4 rounded-lg bg-gray-100 flex flex-col gap-1'>
        <div className='min-h-8'>
          <IconProtect className='text-green-700' />
        </div>
        <p className='text-black font-medium leading-tight'>Transação segura</p>
        <p className='text-sm text-gray-500'>O Pix simplifica suas compras e protege seus dados.</p>
      </div>

      <div className='p-4 rounded-lg bg-gray-100 flex flex-col gap-1'>
        <div className='min-h-8'>
          <IconQRCode className='text-green-700' />
        </div>
        <p className='text-black font-medium leading-tight'>Compre com facilidade</p>
        <p className='text-sm text-gray-500'>Acesse o app do banco, escaneie o QR code ou digite o código.</p>
      </div>
    </div>
  </>;
};

export default Pix;
